import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '../../assets/logos/Logo.png';
import '../login/login.css';
import api from '../../services/api';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Cadastro({ onLogin }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [errors, setErrors] = useState({});
    const [generalError, setGeneralError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const validate = () => {
        const newErrors = {};

        // Nome: Mínimo 3 caracteres
        if (name.trim().length < 3) {
            newErrors.name = 'Nome deve ter pelo menos 3 caracteres.';
        }

        // Email: Regex simples
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            newErrors.email = 'Digite um email válido.';
        }

        // Telefone: Verificar tamanho (assumindo min 10 dígitos para BR com DDD)
        if (!phone || phone.length < 10) {
            newErrors.phone = 'Digite um telefone válido.';
        }

        // Senha: Mínimo 6 caracteres
        if (password.length < 6) {
            newErrors.password = 'Senha deve ter pelo menos 6 caracteres.';
        }

        // Confirmação de Senha
        if (password !== confirmPassword) {
            newErrors.confirmPassword = 'As senhas não coincidem.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setGeneralError('');
        setSuccess('');

        if (!validate()) {
            return;
        }

        setLoading(true);

        try {
            await api.post('/auth/register', {
                name,
                email,
                phone,
                password
            });

            setSuccess('Conta criada com sucesso! Redirecionando para o login...');

            setTimeout(() => {
                navigate('/login');
            }, 2000);

        } catch (err) {
            console.error(err);
            if (err.response && err.response.data && err.response.data.message) {
                setGeneralError(err.response.data.message);
            } else {
                setGeneralError('Erro ao criar conta. Tente novamente.');
            }
            setLoading(false);
        }
    };

    // Estilos customizados para o PhoneInput combinar com o tema
    const phoneInputStyle = {
        width: '100%',
        height: '45px',
        backgroundColor: 'transparent',
        border: 'none',
        borderBottom: '2px solid #fff',
        borderRadius: '0',
        color: '#fff',
        fontSize: '1rem',
        paddingLeft: '48px'
    };

    const phoneContainerStyle = {
        width: '100%',
        marginBottom: '0'
    };

    const phoneButtonStyle = {
        backgroundColor: 'transparent',
        border: 'none',
        borderBottom: '2px solid #fff',
        borderRadius: '0'
    };

    const phoneDropdownStyle = {
        backgroundColor: '#1a1a1a',
        color: '#333'
    };

    return (
        <div className="auth-container">
            <Link to="/" className="auth-logo-link">
                <img src={Logo} className="logo-header" alt="Voltar para Home" />
            </Link>

            <div className="auth-form">
                <h2>Cadastro</h2>
                {generalError && <p className="error-msg" style={{ color: 'red', marginBottom: '1rem' }}>{generalError}</p>}
                {success && <p className="success-msg" style={{ color: '#FF7EAF', marginBottom: '1rem', fontWeight: 'bold' }}>{success}</p>}

                <form onSubmit={handleSubmit}>
                    {/* Nome */}
                    <div className="input-group">
                        <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder=" "
                            required
                        />
                        <label htmlFor="name">Nome Completo</label>
                        {errors.name && <span style={{ color: 'red', fontSize: '0.8rem', display: 'block', marginTop: '5px', textAlign: 'left' }}>{errors.name}</span>}
                    </div>

                    {/* Email */}
                    <div className="input-group">
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder=" "
                            required
                        />
                        <label htmlFor="email">Email</label>
                        {errors.email && <span style={{ color: 'red', fontSize: '0.8rem', display: 'block', marginTop: '5px', textAlign: 'left' }}>{errors.email}</span>}
                    </div>

                    {/* Telefone */}
                    <div className="input-group" style={{ marginBottom: '2.5rem' }}>
                        <PhoneInput
                            country={'br'}
                            value={phone}
                            onChange={phone => setPhone(phone)}
                            inputStyle={phoneInputStyle}
                            containerStyle={phoneContainerStyle}
                            buttonStyle={phoneButtonStyle}
                            dropdownStyle={phoneDropdownStyle}
                            placeholder="Telefone / WhatsApp"
                        />
                        {errors.phone && <span style={{ color: 'red', fontSize: '0.8rem', display: 'block', marginTop: '5px', textAlign: 'left' }}>{errors.phone}</span>}
                    </div>

                    {/* Senha */}
                    <div className="input-group">
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder=" "
                                required
                            />
                            <label htmlFor="password">Senha</label>
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '10px',
                                    cursor: 'pointer',
                                    color: '#fff'
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        {errors.password && <span style={{ color: 'red', fontSize: '0.8rem', display: 'block', marginTop: '5px', textAlign: 'left' }}>{errors.password}</span>}
                    </div>

                    {/* Confirmar Senha */}
                    <div className="input-group">
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder=" "
                                required
                            />
                            <label htmlFor="confirmPassword">Confirmar Senha</label>
                            <span
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '10px',
                                    cursor: 'pointer',
                                    color: '#fff'
                                }}
                            >
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        {errors.confirmPassword && <span style={{ color: 'red', fontSize: '0.8rem', display: 'block', marginTop: '5px', textAlign: 'left' }}>{errors.confirmPassword}</span>}
                    </div>

                    <button type="submit" className="auth-button" disabled={loading}>
                        {loading ? 'Cadastrando...' : 'Cadastrar'}
                    </button>
                </form>

                <div className="auth-link">
                    <p>Já tem uma conta? <Link to="/login">Faça Login</Link></p>
                </div>
            </div>
        </div>
    );
}

export default Cadastro;